import { cn } from '@lib/utils';

export function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn('bg-placeholder/50 animate-pulse rounded-md', className)}
      data-slot="skeleton"
      {...props}
    />
  );
}
